<template>
  <!-- 跟随鼠标移动的效果：里面的小白点 -->
  <div class="cursorWrap">
    <div class="cursor" :style="{ left: cLeft + 'px', top: cTop + 'px' }"></div>
    <!-- 跟随鼠标移动的效果：外面大的透明体 -->
    <div
      class="cursor-follower"
      :style="{ left: cLeft + 'px', top: cTop + 'px' }"
    ></div>
  </div>
</template>

<script>
export default {
  name: "CursorWrap",
  data() {
    return {
      cLeft: 0,
      cTop: 0
    };
  },
  methods: {
    cursor() {
      window.addEventListener("mousemove", ev => {
        let e = ev || event;
        let x = e.clientX || e.pageX,
          y = e.clientY || e.pageY,
          scrollLeft =
            document.documentElement.scrollLeft || document.body.scrollLeft,
          scrollTop =
            document.documentElement.scrollTop ||
            document.body.scrollTop ||
            document.querySelector("#app").scrollTop;
        (this.cLeft = x + scrollLeft), (this.cTop = y + scrollTop);
      });
    }
  },
  mounted() {
    this.cursor();
  }
};
</script>

<style scoped>
.cursor {
  z-index: 999;
  position: absolute;
  background-color: #fff;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  -webkit-transition: 0.2s cubic-bezier(0.75, -0.27, 0.3, 1.33) opacity,
    0.3s cubic-bezier(0.75, -1.27, 0.3, 2.33) -webkit-transform;
  transition: 0.2s cubic-bezier(0.75, -0.27, 0.3, 1.33) opacity,
    0.3s cubic-bezier(0.75, -1.27, 0.3, 2.33) -webkit-transform;
  transition: 0.3s cubic-bezier(0.75, -1.27, 0.3, 2.33) transform,
    0.2s cubic-bezier(0.75, -0.27, 0.3, 1.33) opacity;
  transition: 0.3s cubic-bezier(0.75, -1.27, 0.3, 2.33) transform,
    0.2s cubic-bezier(0.75, -0.27, 0.3, 1.33) opacity,
    0.3s cubic-bezier(0.75, -1.27, 0.3, 2.33) -webkit-transform;
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transition: 0.5s ease-out;
  transition: 0.5s ease-out;
  pointer-events: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.cursor-follower {
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  position: absolute;
  background-color: RGBA(255, 255, 255, 0.3);
  width: 50px;
  height: 50px;
  border-radius: 100%;
  -webkit-transition: 0.2s cubic-bezier(0.75, -0.27, 0.3, 1.33) opacity,
    0.6s cubic-bezier(0.75, -1.27, 0.3, 2.33) -webkit-transform;
  transition: 0.2s cubic-bezier(0.75, -0.27, 0.3, 1.33) opacity,
    0.6s cubic-bezier(0.75, -1.27, 0.3, 2.33) -webkit-transform;
  transition: 0.6s cubic-bezier(0.75, -1.27, 0.3, 2.33) transform,
    0.2s cubic-bezier(0.75, -0.27, 0.3, 1.33) opacity;
  transition: 0.6s cubic-bezier(0.75, -1.27, 0.3, 2.33) transform,
    0.2s cubic-bezier(0.75, -0.27, 0.3, 1.33) opacity,
    0.6s cubic-bezier(0.75, -1.27, 0.3, 2.33) -webkit-transform;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  pointer-events: none;
  z-index: 10000;
  visibility: visible;
  -webkit-transition: 0.7s ease-out;
  transition: 0.7s ease-out;
}

.cursor-follower.close-cursor:before {
  position: absolute;
  content: "";
  height: 25px;
  width: 2px;
  background: #fff;
  left: 48%;
  top: 12px;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  display: inline-block;
}

.cursor-follower.close-cursor:after {
  position: absolute;
  content: "";
  height: 25px;
  width: 2px;
  background: #fff;
  right: 48%;
  top: 12px;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>
